import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import { appGetAllUser } from '../../store/user'
import { useDispatch } from 'react-redux'
import { userExportColumns } from '../../config/exportColumns/userExportColumns'
import { useState } from 'react'
import ExportButton from '../../common/ExportButton'

function User() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [exportFilters, setExportFilters] = useState({})

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Members</div>
					<ExportButton
						fetchAction={params =>
							dispatch(
								appGetAllUser({
									...params,
									...exportFilters,
									hub: hubId || permissionOfHub,
									sansthaId: sansthaId || permissionOfSanstha,
									limit: 100000,
									loading: false,
								}),
							)
						}
						columns={userExportColumns}
						fileName="Users"
						sheetName="User List"
						buttonText="Export Members"
					/>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default User
